import { motion } from "framer-motion";

const STEPS = ["Diagnose", "Design", "Deliver", "Operate"];

/* Editorial "decision → result" ladder. Thin rules, mono labels, drawn on load. */
export const DecisionPath = ({ className = "" }) => (
  <svg viewBox="0 0 420 460" className={className} aria-hidden fill="none">
    <text x="24" y="28" className="label" fill="currentColor" fillOpacity="0.55" fontSize="11" letterSpacing="2.4">DECISION</text>
    <text x="24" y="448" className="label" fill="currentColor" fillOpacity="0.55" fontSize="11" letterSpacing="2.4">RESULT</text>
    <motion.line
      x1="40" y1="48" x2="40" y2="424" stroke="currentColor" strokeOpacity="0.25" strokeWidth="1"
      initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 1.6, ease: "easeInOut", delay: 0.3 }}
    />
    <motion.line
      x1="40" y1="48" x2="40" y2="424" stroke="#0133BA" strokeWidth="2"
      initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 1.8, ease: [0.16, 1, 0.3, 1], delay: 0.6 }}
    />
    {STEPS.map((s, i) => {
      const y = 96 + i * 96;
      return (
        <motion.g key={s} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.9 + i * 0.22, duration: 0.6 }}>
          <circle cx="40" cy={y} r="5" fill="#FAFAF8" stroke="#0133BA" strokeWidth="2" />
          <line x1="52" y1={y} x2="290" y2={y} stroke="currentColor" strokeOpacity="0.14" strokeWidth="1" />
          <text x="64" y={y - 10} fill="currentColor" fontSize="11" fontFamily="'DM Mono', monospace" fillOpacity="0.55" letterSpacing="2">{`0${i + 1}`}</text>
          <text x="64" y={y + 20} fill="currentColor" fontSize="18" fontFamily="Inter, sans-serif" fontWeight="600">{s}</text>
        </motion.g>
      );
    })}
    <motion.rect
      x="300" y="364" width="80" height="40" rx="20" stroke="#0133BA" strokeWidth="1.25" fill="#0133BA" fillOpacity="0.06"
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 2, duration: 0.6 }}
    />
    <motion.text
      x="340" y="388" textAnchor="middle" fill="#0133BA" fontSize="11" fontFamily="'DM Mono', monospace" letterSpacing="1.5"
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 2.1, duration: 0.6 }}
    >
      OWNED
    </motion.text>
  </svg>
);

/* Four-column rhythm bar used in the operating-method section */
export const RhythmBar = ({ className = "" }) => (
  <div aria-hidden className={`relative h-px w-full bg-white/15 ${className}`}>
    <motion.div
      className="absolute left-0 top-0 h-px bg-white"
      initial={{ width: "0%" }} whileInView={{ width: "100%" }} viewport={{ once: true }}
      transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
    />
  </div>
);
